/* eslint-disable react/prop-types */
import SoftBox from "components/SoftBox";
import SoftDatePicker from "components/SoftDatePicker";
import SoftTypography from "components/SoftTypography";
import { ErrorMessage, Field } from "formik";
import React from "react";
import { useLocation, useParams } from "react-router-dom";

export default function DatepickerField({ name, value, type, label, ...rest }) {
  return (
    <SoftBox mb={1.5}>
      <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
        <SoftTypography component="label" variant="caption" fontWeight="bold">
          {label}
        </SoftTypography>
      </SoftBox>
      <Field name={name} component={DatepickerComp} {...rest} />
      <SoftBox mt={0.75}>
        <SoftTypography component="div" variant="caption" color="error">
          <ErrorMessage name={name} />
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

function DatepickerComp(props) {
  const {
    options,
    error,
    success,
    placeholder,
    form: { setFieldValue, ...formRest },
    field: { name, value, onBlur },
  } = props;

  const { id } = useParams();
  const location = useLocation();
  const containEdit = location.pathname?.includes("/edit");
  const disabled = id && !containEdit;

  return (
    <SoftDatePicker
      {...props}
      options={options}
      value={value}
      onChange={(newDate) => {
        setFieldValue(name, new Date(newDate?.[0]).getTime());
      }}
      input={{
        ...{
          onBlur,
          name,
          error: !disabled && error,
          success: !containEdit && !disabled && success,
          placeholder,
        },
        ...props,
      }}
    />
  );
}
